"use client"

import { forwardRef } from "react"
import { Search, X } from "lucide-react"
import "./skills-search-bar.less"

export interface SkillsSearchBarProps {
  query: string
  onQueryChange: (value: string) => void
  onSearch: () => void
  onClear: () => void
  onKeyDown: (e: React.KeyboardEvent) => void
  hasSearched: boolean
  isDocked: boolean
}

export const SkillsSearchBar = forwardRef<HTMLInputElement, SkillsSearchBarProps>(
  function SkillsSearchBar(
    { query, onQueryChange, onSearch, onClear, onKeyDown, hasSearched, isDocked },
    ref,
  ) {
    return (
      <div className="liquid-glass-surface rounded-full h-full">
        <div className="relative group h-full rounded-full overflow-hidden">
          <input
            ref={ref}
            type="text"
            value={query}
            onChange={(e) => onQueryChange(e.target.value)}
            onKeyDown={onKeyDown}
            placeholder="搜索技能、功能或标签..."
            className={`skills-search-bar__input ${isDocked ? "skills-search-bar__input--docked" : "skills-search-bar__input--undocked"
              }`}
          />
          <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-1">
            {query && (
              <button
                aria-label="清空搜索内容"
                onClick={() => onQueryChange("")}
                className={`skills-search-bar__clear-btn ${isDocked ? "skills-search-bar__clear-btn--docked" : "skills-search-bar__clear-btn--undocked"
                  }`}
              >
                <X className={isDocked ? "skills-search-bar__icon--sm" : "skills-search-bar__icon--md"} />
              </button>
            )}
            <button
              aria-label="搜索"
              onClick={onSearch}
              className={`skills-search-bar__search-btn ${isDocked ? "skills-search-bar__search-btn--docked" : "skills-search-bar__search-btn--undocked"
                }`}
            >
              <Search className={isDocked ? "skills-search-bar__icon--sm" : "skills-search-bar__icon--md"} />
            </button>
          </div>
        </div>
      </div>
    )
  },
)
